module.exports = __webpack_public_path__ + "img/icon-video-small.ccd41615.svg";